
import { defineComponent } from 'vue'
import {
  heroOutline24ChartBar,
  heroOutline24Bolt,
  heroOutline24DevicePhoneMobile,
  heroOutline24CreditCard,
  heroOutline24Squares2x2,
  heroOutline24Share,
  heroOutline24Wrench,
  heroOutline24Users,
  heroOutline24CircleStack,
  heroOutline24DocumentText,
  heroOutline24ChatBubbleLeftRight,
  heroOutline24ChevronDown,
} from 'quasar-extras-svg-icons/hero-icons-v2'

export default defineComponent({
  name: 'HeaderMenu',
  setup() {
    return {
      heroOutline24ChartBar,
      heroOutline24Bolt,
      heroOutline24DevicePhoneMobile,
      heroOutline24CreditCard,
      heroOutline24Squares2x2,
      heroOutline24Share,
      heroOutline24Wrench,
      heroOutline24Users,
      heroOutline24CircleStack,
      heroOutline24DocumentText,
      heroOutline24ChatBubbleLeftRight,
      heroOutline24ChevronDown,
    }
  },
})
